import {Injectable} from '@angular/core';
import {Hotkey, HotkeysService} from 'angular2-hotkeys';
import {Observable, Subject} from 'rxjs';

export class HotkeyConfig {
  [key: string]: string[];
}

export class ConfigModel {
  hotkeys: HotkeyConfig;
}

export class Command {
  name: string;
  combo: string;
  ev: KeyboardEvent;
}

@Injectable({
  providedIn: 'root'
})
export class GtCommandService {
  static readonly NAVIGATE_USER = 'Navigate.User';
  static readonly NAVIGATE_SWITCHBOARD = 'Navigate.Switchboard';
  static readonly NAVIGATE_SWITCHBOARD_SMS = 'Navigate.Switchboard.SMS';
  static readonly NAVIGATE_SWITCHBOARD_STAT = 'Navigate.Switchboard.Stat';
  static readonly NAVIGATE_ADMIN = 'Navigate.Admin';
  static readonly NAVIGATE_WALLBOARD = 'Navigate.Wallboard';
  static readonly NAVIGATE_CONFERENCE = 'Navigate.Conference';
  static readonly NAVIGATE_PHONE = 'Navigate.Phone';
  static readonly COMMAND_ENDCURRENTCALL = 'Command.EndCurrentCall';
  static readonly COMMAND_CALLORCONSULT = 'Command.CallOrConsult';
  static readonly COMMAND_TOGGLE = 'Command.Toggle';
  static readonly COMMAND_HOLDORRETRIEVE = 'Command.HoldOrRetrieve';
  static readonly COMMAND_TRANSFER = 'Command.Transfer';
  static readonly COMMAND_SMS = 'Command.SMS';
  static readonly COMMAND_SEARCH = 'Command.Search';
  static readonly COMMAND_TOGGLEAGENTSTATE = 'Command.ToggleAgentState';

  static readonly COMMAND_DEMO_ESTABLISED = 'demo established';
  static readonly COMMAND_DEMO_INCOMING = 'demo incoming';
  static readonly COMMAND_DEMO_QUEUED = 'demo queued';
  static readonly COMMAND_DEMO_DEQUEUED = 'demo dequeued';
  static readonly COMMAND_DEMO_DISCONNECT = 'demo hangup';
  static readonly COMMAND_DEMO_ANSWERED = 'demo answered';

  config: ConfigModel = {
    /* eslint-disable quote-props */
    hotkeys: {
      'n u': [GtCommandService.NAVIGATE_USER],
      'n s': [GtCommandService.NAVIGATE_SWITCHBOARD],
      'n m': [GtCommandService.NAVIGATE_SWITCHBOARD_SMS],
      'n l': [GtCommandService.NAVIGATE_SWITCHBOARD_STAT],
      'n a': [GtCommandService.NAVIGATE_ADMIN],
      'n w': [GtCommandService.NAVIGATE_WALLBOARD],
      'n c': [GtCommandService.NAVIGATE_CONFERENCE],
      'n p': [GtCommandService.NAVIGATE_PHONE],
      esc: [GtCommandService.COMMAND_ENDCURRENTCALL],
      f2: [GtCommandService.COMMAND_CALLORCONSULT],
      f3: [GtCommandService.COMMAND_TOGGLE],
      f4: [GtCommandService.COMMAND_HOLDORRETRIEVE],
      f5: [GtCommandService.COMMAND_TRANSFER],
      f6: [GtCommandService.COMMAND_SMS],
      f7: [GtCommandService.COMMAND_SEARCH],
      f8: [GtCommandService.COMMAND_TOGGLEAGENTSTATE],
      'd e': [GtCommandService.COMMAND_DEMO_ESTABLISED],
      'd i': [GtCommandService.COMMAND_DEMO_INCOMING],
      'd q': [GtCommandService.COMMAND_DEMO_QUEUED],
      'd d': [GtCommandService.COMMAND_DEMO_DISCONNECT],
      'd a': [GtCommandService.COMMAND_DEMO_ANSWERED],
      'd c': [GtCommandService.COMMAND_DEMO_DEQUEUED]
    } as HotkeyConfig
    /* eslint-enable quote-props */
  };

  private subject: Subject<Command>;
  commands: Observable<Command>;

  constructor(private hotkeysService: HotkeysService) {
    this.subject = new Subject<Command>();
    this.commands = this.subject.asObservable();

    for (const key of Object.keys(this.config.hotkeys)) {
      const commands = this.config.hotkeys[key];
      hotkeysService.add(new Hotkey(key, (ev, combo) => this.hotkey(ev, combo, commands)));
    }
  }

  private hotkey(ev: KeyboardEvent, combo: string, commands: string[]): boolean {
    commands.forEach(c => {
      const command = {
        name: c,
        ev,
        combo
      } as Command;
      this.subject.next(command);
    });
    return true;
  }
}
